module.exports = __webpack_public_path__ + "static/media/thanks-bot.6379a3d0.gif";